'use strict';
import angular from 'angular';
import './base/industrybenchmarkpaidmedia.resources';


angular.module('core.industrybenchmarkpaidmedia', [
    'industrybenchmarkpaidmedia.resources'
]);